
const state = {
    apiConfig: {
        api: "",
        timeout: "",
        edu_addr: ""
    },
    networkState: true,
    token: null,
    auth: null,
    locale: "zh-cn",
    foodClassify:[],
    foodInfo:[],
    // seq:[],
}
export default state;